import type { InsuranceTab } from '~/components/widget/insurance-calculators/types'

export const insuranceTabs: InsuranceTab[] = [
  {
    id: 'osago',
    label: 'page.about.services.osago',
    url: 'https://policy.insurancebakai.kg/calculator/osago?source=landing'
  },
  {
    id: 'kasko',
    label: 'common.kasko',
    url: 'https://policy.insurancebakai.kg/calculator/kasko?source=landing'
  },
  {
    id: 'travel',
    label: 'common.traveling',
    url: 'https://policy.insurancebakai.kg/calculator/vzr?source=landing'
  },
  {
    id: 'health',
    label: 'common.life_and_health',
    url: 'https://policy.insurancebakai.kg/calculator/ns?source=landing'
  },
  {
    id: 'passengers',
    label: 'common.passengers',
    url: 'https://policy.insurancebakai.kg/calculator/osgopp?source=landing'
  },
  {
    id: 'employees',
    label: 'insurance.types.employees',
    url: 'https://policy.insurancebakai.kg/calculator/employees?source=landing'
  },
  {
    id: 'cargo',
    label: 'insurance.types.cargo',
    url: 'https://policy.insurancebakai.kg/calculator/cargo?source=landing'
  },
  {
    id: 'objects',
    label: 'insurance.types.objects',
    url: 'https://policy.insurancebakai.kg/calculator/objects?source=landing'
  }
]
